// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"048a3b2b","239":"02453a25","292":"b3ad8920","453":"edd102e0","575":"91ff974c","582":"3453eb79","593":"ce318153","652":"b6f24e29","683":"b7c521f8","834":"ca93ae6d","839":"fa27e150","859":"2be1c10b"}[chunkId] + ".chunk.js";
};